// @flow

import { useEffect } from 'react';

/**
 * Prevents body from scrolling when node is shown
 */
const useDisableScrollOnShow = () => {
  useEffect(() => {
    const body = document.body;

    // Mostly for flow but don't do anything if there is no body
    if (!body) {
      return () => {};
    }

    // Store our current overflow so we can restore it later
    const previousOverflow = body.style.overflow;

    // This prevents scrolling from happening on the body
    body.style.overflow = 'hidden';

    return () => {
      // On dismount undo all of the scroll fixing we did on mount
      body.style.overflow = previousOverflow;
    };
  });
};

export default useDisableScrollOnShow;
